/** Parita s `backend/auth-service/src/config/password.config.ts` (výchozí politika). */
export const PASSWORD_POLICY_HINT =
  'Heslo musí mít alespoň 8 znaků, jedno malé písmeno, jedno velké písmeno a jednu číslici.';

export interface PasswordPolicyResult {
  isValid: boolean;
  errors: string[];
}

export function validatePasswordPolicy(password: string): PasswordPolicyResult {
  const errors: string[] = [];
  if (password.length < 8) {
    errors.push('Heslo musí mít alespoň 8 znaků.');
  }
  if (!/[A-Z]/.test(password)) {
    errors.push('Heslo musí obsahovat alespoň jedno velké písmeno.');
  }
  if (!/[a-z]/.test(password)) {
    errors.push('Heslo musí obsahovat alespoň jedno malé písmeno.');
  }
  if (!/\d/.test(password)) {
    errors.push('Heslo musí obsahovat alespoň jednu číslici.');
  }
  return { isValid: errors.length === 0, errors };
}

/** Mapuje anglické zprávy ze starších API odpovědí na češtinu. */
export function mapPasswordPolicyApiError(message: string): string {
  const lower = message.toLowerCase();
  if (lower.includes('uppercase')) return 'Heslo musí obsahovat alespoň jedno velké písmeno.';
  if (lower.includes('lowercase')) return 'Heslo musí obsahovat alespoň jedno malé písmeno.';
  if (lower.includes('number') || lower.includes('digit')) return 'Heslo musí obsahovat alespoň jednu číslici.';
  if (lower.includes('at least') && lower.includes('character')) return 'Heslo musí mít alespoň 8 znaků.';
  if (lower.includes('heslo')) return message;
  return message;
}
